












































import { Component, Prop, Vue } from 'vue-property-decorator';

const tenji = require('tenji')

function isHeader (line:string) :boolean {
  if (line.split('⠒').length > 5) {
    return false
  }

  if (line.length < 5) {
    return false
  }
  return true
}

function splitbraille (str:string):object {
  let pages:string[]  = str.split('@PB@')
  let bodys:any[] = []
  let titles:string[] = []
  let docTitle:boolean| string = false

  pages.forEach(page => {
    const lines:string[] = page.split('@LB@')
    let headding = false
    let p:string[] = []
    let trimLine:string = ''

    lines.forEach(line => {
      trimLine = line.replace(/^⠀+|⠀+$/g, '')
      if (headding === false) {
        if (isHeader(trimLine)) {
          titles.push(trimLine)
          if (docTitle === false) {
            docTitle = trimLine
            line = '@H1@' + line
          } else {
            line = '@H2@' + line
          }
          headding = true
        }
      }
      p.push(line as string)
    })

    // ページの見出しが見つからない場合は最初の行を見出しとする
    if (headding === false) {
      titles.push('⠀⠀')
    }
    bodys.push(p)
  })

  return {
    docTitle: docTitle,
    title: titles,
    body: bodys
  }
}

/*
export default {
  name: 'braille',
  props: ['braille', 'checkYomi'],
  computed: {
    isFileClose: function () {
      return this.braille.length === 0
    },
    bes: function () {
      return splitbraille(this.braille)
    }
  },
  methods: {
    tenji2yomi: function (str) {
      let line = str
      if (line.substr(0, 4) === '@H1@') { line = line.slice(4) }
      if (line.substr(0, 4) === '@H2@') { line = line.slice(4) }
      if (line.substr(0, 4) === '@HR@') { line = '<hr />' }
      if (line.length === 0) { line = '<br />' }
      return tenji.fromTenji(line)
    }
  }
}
*/

@Component
export default class Braille extends Vue {
  @Prop({ default: '' })
  braille!: string;

  @Prop({ default: false })
  checkYomi!:boolean;

  get isFileClose(){
      return this.braille.length === 0
  }

  get bes(){
      return splitbraille(this.braille)
  }

  tenji2yomi(str:string) :string {
      let line:string = str
      if (line.substr(0, 4) === '@H1@') { line = line.slice(4) }
      if (line.substr(0, 4) === '@H2@') { line = line.slice(4) }
      if (line.substr(0, 4) === '@HR@') { line = '<hr />' }
      if (line.length === 0) { line = '<br />' }
      return tenji.fromTenji(line)
    }
  
}

